import { CheckInKioskAthletePreviewFragment, KioskMealMenuPreviewFragment } from "../../../types";

export const mealMenuAppliesToAthlete = (
  athlete: Pick<CheckInKioskAthletePreviewFragment, "id">,
  mealMenu: Pick<KioskMealMenuPreviewFragment, "athletes">
) => mealMenu.athletes.map(a => a.id).includes(athlete.id);

export const athleteCheckedIntoMealMenu = (athlete: Pick<CheckInKioskAthletePreviewFragment, "checkInsForMealMenus">, mealMenuId: string) =>
  athlete.checkInsForMealMenus.map(cimm => cimm.mealMenuId).includes(mealMenuId);
